import { FormControl, FormField } from '@/components/ui/Form';
import { Checkbox, Form, FormItem } from '@/components/wm';
import { zodResolver } from '@hookform/resolvers/zod';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export function TermsForm ({ data, onChangeField, onCompleted }) {
    const [termsScrolledToBottom, setTermsScrolledToBottom] = useState(false);
    const termsRef = useRef(null);

    const formSchema = z.object({
        acceptedTerms: z.literal(true, {
            errorMap: () => ({ message: 'you must accept the terms and conditions to proceed' })
        }),
        marketing: z.boolean()
    });

    const handleScroll = () => {
        const el = termsRef.current;
        if (!el) {
            return;
        }
        const scrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
        setTermsScrolledToBottom(scrolledToBottom);
    };

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            acceptedTerms: data.acceptedTerms || false,
            marketing: data.marketing || false
        },
        mode: 'onChange'
    });

    useEffect(() => {
        onCompleted(form.formState.isValid);
    }, [form.formState.isValid]);

    return (
        <>
            {/* These terms are a placeholder and need to be changed */}
            <div
                className="tw-max-h-full tw-overflow-y-scroll tw-border tw-border-solid tw-border-border tw-rounded-lg tw-p-6 tw-h-64"
                onScroll={handleScroll}
                ref={termsRef}
            >
                <p>{i18next.t('terms.effective_date')}</p>
                <br/>
                {Object.entries(i18next.t('terms.chapters', { returnObjects: true })).map(([key, chapter], idx) => (
                    <React.Fragment key={key}>
                        <p className="tw-mt-2">{chapter.title}</p>
                        <p>{chapter.text}</p>
                        {chapter.extra && (
                            <ul className="tw-list-disc tw-ml-4 tw-space-y-1 tw-clear-float-list">
                                {Object.values(chapter.extra).map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        )}
                        <br/>
                    </React.Fragment>
                ))}
            </div>
            <Form {...form} className="!tw-max-w-full tw-w-full">
                <FormField
                    control={form.control}
                    name="acceptedTerms"
                    render={({ field }) => (
                        <FormItem>
                            <FormControl>
                                <div className="tw-items-top tw-flex tw-space-x-2 tw-mt-4 tw-mb-0 tw-ml-6">
                                    <Checkbox
                                        checked={field.value}
                                        disabled={!termsScrolledToBottom}
                                        id="acceptedTerms"
                                        onCheckedChange={e => {
                                            field.onChange(e);
                                            onChangeField('acceptedTerms')(e);
                                        }}
                                    />
                                    <label
                                        className="tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70"
                                        htmlFor="acceptedTerms"
                                    >
                                        {i18next.t('terms.accept_terms')}
                                    </label>
                                </div>
                            </FormControl>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="marketing"
                    render={({ field }) => (
                        <FormItem>
                            <FormControl>
                                <div className="tw-items-top tw-flex tw-space-x-2 tw-mt-0 tw-mb-8 tw-ml-6">
                                    <Checkbox
                                        checked={field.value}
                                        id="marketing"
                                        onCheckedChange={e => {
                                            field.onChange(e);
                                            onChangeField('marketing')(e);
                                        }}
                                    />
                                    <label
                                        className="tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70"
                                        htmlFor="marketing"
                                    >
                                        {i18next.t('terms.marketing_opt_in')}
                                    </label>
                                </div>
                            </FormControl>
                        </FormItem>
                    )}
                />
            </Form>
        </>
    );
}
